export default class FormService {
  static requiredStringRule = (v: string) => !!v || "Required";

  static emailFormatRule = (v: string) =>
    /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(v) && v.length > 8 ||
    v === "" ||
    v == null ||
    "E-mail must be valid";

  static requiredNumberRule = (v: number) => !!v || "Required";

  static positiveNumberRule = (v: number) => v > 0 || "Must be Positive";

  static phoneNumberFormatRule = (v: string) =>
    (/\+[0-9() -]+$/.test(v) && !/[-()]{2,}$/.test(v)) ||
    v === "" ||
    v === null ||
    "Phone Number must be valid";

  static formatPhoneNumber(s: string): string {
    return s.replace(/[()-]/g, " ").replace(/\s{2,}/g, " ");
  }

  static maxLength255 = (v: String) =>
    (v && v.length <= 255) || "Must less than 256 characters";
}
